import React from "react";
import { workzonesTableTitles } from "../../../utils/constants";
import "./workzonesTable.scss";
import { WorkzonesTableProps } from "./types";
import { WorkzoneDetailType } from "sagas/types/regions";
import { formatDDMMYYYY, formatHHMM } from "utils/date";
import "./i18n";
import { useTranslation } from "react-i18next";

export const WorkzonesTable = ({
  workzones,
  timezone,
  testId,
}: WorkzonesTableProps) => {
  const { t } = useTranslation();
  return (
    <div className="container-workzones-table">
      <div className="container-workzones-table-row workzones-table-header">
        {workzonesTableTitles.map((title: { label: string; id: string }) => (
          <div
            key={title.label}
            className="container-workzones-table-col-sm-1 header-cell"
            data-testId={`${testId}-title-${title.id}`}
          >
            {t(title.label)}
          </div>
        ))}
      </div>

      {workzones.length > 0 ? (
        <div
          className={[
            "container-workzones-scroll",
            workzones?.length > 5 && "visible",
          ].join(" ")}
        >
          {workzones.map((workzone: WorkzoneDetailType, index) => (
            <div
              id={`${workzone.id}`}
              className="container-workzones-table-row workzones-table-row"
              key={workzone.id}
            >
              <div
                className="container-workzones-table-col-sm-1"
                data-testId={`${testId}-row-${index + 1}-last-change-date`}
              >
                {workzone.updatedAt
                  ? formatDDMMYYYY(workzone.updatedAt, timezone)
                  : "-"}
              </div>
              <div
                className="container-workzones-table-col-sm-1"
                data-testId={`${testId}-row-${index + 1}-last-change-time`}
              >
                {workzone.updatedAt
                  ? formatHHMM(workzone.updatedAt, timezone)
                  : "-"}
              </div>
              <div
                className="container-workzones-table-col-sm-1"
                data-testId={`${testId}-row-${index + 1}-name`}
              >
                {workzone.name || "-"}
              </div>
              <div
                className="container-workzones-table-col-sm-1"
                data-testId={`${testId}-row-${index + 1}-max-transactions`}
              >
                {workzone.maxTransactions || "0"}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="workzones-empty-message">
          <p data-testId={`${testId}-empty-message`}>
            {t("workzonesTable:selectRegion")}
          </p>
        </div>
      )}
      {workzones.length > 5 && <div className="workzones-table-transparent" />}
    </div>
  );
};
